module.exports = __webpack_public_path__ + "b47cc53db642ddf6f5876ebb222a6310.png";